import { css } from '@emotion/react'

// Tokens captured from Figma. We prefer Lapidary primitives where they apply
// (Modal, Button, Select); these styles cover the bits that don't have a
// direct Lapidary mapping (caption row container, file pill, "+ Add caption
// file" button variant).

export const modalContent = css({
  width: 500,
  borderRadius: 12,
  boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.24)',
})

export const modalBody = css({
  padding: '24px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
})

export const captionsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  background: '#F9FAFC',
  borderRadius: 8,
})

export const captionRow = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 12,
  padding: 12,
})

export const filePill = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  flex: '1 1 0',
  height: 32,
  padding: '0 8px',
  border: '1px solid #D9DADB',
  borderRadius: 4,
  fontFamily: 'Proxima Nova',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '18px',
  color: '#1A1A1A',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const filePillName = css({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const languageSelect = css({
  flex: '1 1 0',
  minWidth: 166,
  '& button': {
    height: 32,
    minHeight: 32,
  },
})

export const removeButton = css({
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  color: '#5F6061',
  padding: 0,
  width: 32,
  height: 32,
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  '&:focus-visible': {
    outline: '2px solid #2A70EA',
  },
})

export const addCaptionButton = css({
  alignSelf: 'flex-start',
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 5,
  padding: '6px 8px',
  background: '#F6F9FE',
  border: '1px solid #C4D6F5',
  borderRadius: 4,
  cursor: 'pointer',
  fontFamily: 'Proxima Nova',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '21px',
  color: '#2866D3',
  '&:hover': {
    background: '#EAF1FD',
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
})

export const footer = css({
  alignItems: 'center',
  justifyContent: 'flex-end',
})

export const footerButtons = css({
  display: 'flex',
  flexDirection: 'row',
  gap: 12,
})

export const hiddenFileInput = css({
  display: 'none',
})
